import { AnimatePresence } from "framer-motion";
import React, { useId } from "react";

export default function SnkrsWrapAnimatePresence(props) {
    return (
        <>
            <AnimatePresence {...props} />
        </>
    );
}

export function PreventAnimationBubble({ children, ...other }) {
    const id = useId();

    return (
        <SnkrsWrapAnimatePresence {...other}>
            <React.Fragment key={id}>
                {children}
            </React.Fragment>
        </SnkrsWrapAnimatePresence>
    );
}
